export const SelectedRangeModel = Symbol.for('SelectedRangeModel');
